export function NoAccessPage() {
  return (
    <main className="flex min-h-[60vh] items-center justify-center px-6">
      <div className="flex flex-col items-center gap-2 text-center">
        <p className="text-body font-medium text-foreground">
          You don&apos;t have access to this area.
        </p>
        <p className="text-body-sm text-muted-foreground">Ask an Administrator if you need it.</p>
      </div>
    </main>
  )
}
